module.exports = __webpack_public_path__ + "8705ee7a12b394bf8e54445442ea1936.svg";